import { RelatedPosts } from "@iscr/contentful/pages/blog/blog-post/RelatedPosts";
import { useLocation } from "react-router";
import {capitalize} from "@iscr/helpers/prettify";
import { useContentfulPage } from "@iscr/contentful/context/ContentfulPageContext";
import { TEMPLATE_IDS } from "@iscr/contentful/constants";

export const RelatedBlogInfoCards = (props) => {
	const loc = useLocation();
	const slug = loc?.pathname.split("/").filter(Boolean).pop();
	const title = capitalize(slug?.replace(/^treatment-/, "")?.replace(/-/g, " ")) || "";
	const config = props?.config?.[0];
	const tag = `BlogPost_${config?.blogTag ?? title.replace(/ /g, "")}`;
	const styling = {backgroundColor: config?.cardBg};

	return (
		<RelatedPosts postId="" tag={tag} type={TEMPLATE_IDS.CONDITIONS_LANDING_PAGE} styling={{cardStyling: styling}} title={`Learn more about ${title} online`} />
	);
};

